import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n'
  import AttentionIcon from '@/assets/AttentionIcon.vue'
  import { useStore } from '@/store'
  import { ModalId } from '@/config/modalIds'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MissingTravellerInfoWarning',
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  setup(__props) {

  const { t } = useI18n()
  const store = useStore()

  const props = __props

  const openTravellerPanel = () => {
    store.dispatch('booking/selectBooking', props.booking)
    store.commit('modal/open', ModalId.TRAVELLER_PANEL)
    store.commit('modal/open', ModalId.BOOKING_PANEL)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: "body mb-2 mt-2 fw-bold d-flex align-items-center",
    style: {"color":"#fe6100","cursor":"pointer"},
    onClick: openTravellerPanel
  }, [
    _createVNode(AttentionIcon),
    _createTextVNode(" " + _toDisplayString(_unref(t)('reservations.missingTravellerInfoWarning')), 1)
  ]))
}
}

})